import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { IndexType } from '@fnModels/algolia/algolia';
import { getIndex } from '@state/utils/helper';
import { AlgoliaBaseState, AlgoliaSearchState } from '..';
import * as actions from './financial-institution-branch-search.actions';

export type FinancialInstitutionBranchSearchStateModel =
	AlgoliaBaseState<unknown>;

@State<FinancialInstitutionBranchSearchStateModel>({
	name: 'financialInstitutionBranchSearch',
	defaults: {
		searchTerm: '',
		searching: false,
		success: null,
		error: null,
		items: [],
	},
})
@Injectable()
export class FinancialInstitutionBranchSearchState extends AlgoliaSearchState<FinancialInstitutionBranchSearchStateModel> {
	protected indexName = getIndex(IndexType.FINANCIAL_INSTITUTIONS_BRANCHES);

	@Selector([FinancialInstitutionBranchSearchState])
	static getList(state: FinancialInstitutionBranchSearchStateModel) {
		return state?.items;
	}

	@Action(actions.Search)
	async search(
		ctx: StateContext<FinancialInstitutionBranchSearchStateModel>,
		{ payload }: actions.Search,
	) {
		const facetFilters = [];
		if (payload.institutionId) {
			facetFilters.push(`institutionId:${payload.institutionId}`);
		}

		await this.algoliaSearchHandler(ctx, payload.searchValue, { facetFilters });
	}
}
